<template>
  <WdsTooltip>
    <template #tooltip-content>
      {{ $t('Number of payment requests') }}
      <br />
      {{ $t('Pending') }} / {{ $t('Total') }}
    </template>

    <WdsTag class="tw-whitespace-nowrap" :warning md>
      <template v-if="warning">&#x2022;</template>
      {{ numberPending }} / {{ numberOfRequests }}
    </WdsTag>
  </WdsTooltip>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsTag, WdsTooltip } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const PaymentRequestSpecification = graphql(`
  fragment PaymentRequestSpecification on PaymentRequest {
    id
    workerStatus
    completedAt
  }
`)

const HirePaymentRequestColumn = graphql(`
  fragment HirePaymentRequestColumn on Hire {
    id

    paymentRequests(first: 100000, page: 1) {
      data {
        ...PaymentRequestSpecification
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof HirePaymentRequestColumn> }>()
const column = computed(() => useFragment(HirePaymentRequestColumn, props.row))

const numberOfRequests = computed(() => column.value?.paymentRequests?.data?.length ?? 0)
const numberPending = computed(() => {
  const paymentRequests =
    column.value?.paymentRequests?.data?.map((request) =>
      useFragment(PaymentRequestSpecification, request),
    ) ?? []
  return paymentRequests.map((request) => !request.completedAt).reduce((a, b) => a + Number(b), 0)
})

const warning = computed(() => numberPending.value > 0)
</script>

<style lang="scss"></style>
